import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import LevelPage from "@/pages/LevelPage";
import TopicDetail from "@/pages/TopicDetail";
import Centenario from "@/pages/Centenario";
import Oracion from "@/pages/Oracion";
import Eucaristia from "@/pages/Eucaristia";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import StudentDashboard from "@/pages/StudentDashboard";
import CatechistDashboard from "@/pages/CatechistDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";

const TAU = "https://static.prod-images.emergentagent.com/jobs/fd0f3bbe-b357-48f6-aef4-a23c6e5b4fd7/images/90b9622f20e196612703a7d7c1f1ec7fa5d672234dbbf161661a04db600423c2.png";
const DOVE = "https://static.prod-images.emergentagent.com/jobs/fd0f3bbe-b357-48f6-aef4-a23c6e5b4fd7/images/c25b4cad97374f0313103a62c4cd65558dedf4529ed70aa000a4345f7b49b82a.png";

function AppShell() {
  const location = useLocation();
  // Detect Emergent Google session_id callback synchronously
  if (location.hash?.includes("session_id=")) {
    return (
      <div className="min-h-screen flex flex-col bg-background text-foreground">
        <Header />
        <main className="flex-1"><AuthCallback /></main>
      </div>
    );
  }
  const hideChrome = location.pathname === "/login";
  const isDashboard = location.pathname.startsWith("/dashboard");

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/primera-comunion" element={
            <ProtectedRoute><LevelPage level="primera_comunion" title="Primera Comunión" subtitle="Camino hacia el encuentro con Jesús Eucaristía." accentImage={TAU} /></ProtectedRoute>
          } />
          <Route path="/confirmacion" element={
            <ProtectedRoute><LevelPage level="confirmacion" title="Confirmación" subtitle="Sellados por el Espíritu, enviados como testigos." accentImage={DOVE} /></ProtectedRoute>
          } />
          <Route path="/tema/:id" element={
            <ProtectedRoute><TopicDetail /></ProtectedRoute>
          } />
          <Route path="/centenario" element={<Centenario />} />
          <Route path="/oracion" element={<Oracion />} />
          <Route path="/eucaristia" element={<Eucaristia />} />
          <Route path="/dashboard/estudiante" element={
            <ProtectedRoute role="student"><StudentDashboard /></ProtectedRoute>
          } />
          <Route path="/dashboard/catequista" element={
            <ProtectedRoute role="catechist"><CatechistDashboard /></ProtectedRoute>
          } />
        </Routes>
      </main>
      {!hideChrome && !isDashboard && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
